import {
  StructuredError,
  structuredErrorToFieldErrorPairs,
} from '../../../services/BaseBackendService';

export function mapWizardStructuredError(error: unknown): {
  validationErrors?: { [key: string]: string };
  message?: string;
} {
  if (error && typeof error === 'object' && 'structuredError' in error) {
    return {
      validationErrors: structuredErrorToFieldErrorPairs(error as StructuredError),
    };
  }

  return {
    message: error instanceof Error ? error.message : undefined,
  };
}
